import { Capacitor } from '@capacitor/core';

export const getPlatform = () => Capacitor.getPlatform();
